import script from "./code-input.vue?vue&type=script&setup=true&lang=js"
export * from "./code-input.vue?vue&type=script&setup=true&lang=js"

import "./code-input.vue?vue&type=style&index=0&id=33c3a7eb&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c3a7eb"]])

export default __exports__